import { render, staticRenderFns } from "./NewMoon.vue?vue&type=template&id=3665dc25&scoped=true&"
import script from "./NewMoon.vue?vue&type=script&lang=js&"
export * from "./NewMoon.vue?vue&type=script&lang=js&"
import style0 from "./NewMoon.vue?vue&type=style&index=0&id=3665dc25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3665dc25",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3665dc25')) {
      api.createRecord('3665dc25', component.options)
    } else {
      api.reload('3665dc25', component.options)
    }
    module.hot.accept("./NewMoon.vue?vue&type=template&id=3665dc25&scoped=true&", function () {
      api.rerender('3665dc25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/月亮日記/NewMoon.vue"
export default component.exports